import * as brokerages from './brokerages';
import * as filters from './filters';
import * as lendersByProducts from './lendersByProducts';
import * as products from './products';
import * as settings from './settings';
import * as users from './users';

export default {
  brokerages,
  filters,
  lendersByProducts,
  products,
  settings,
  users,
};
